document.addEventListener('DOMContentLoaded', function () {
    console.log('Custom script loaded');

    const requiredCheckbox = document.getElementById('register-form__agreement-required');
    const optionalCheckbox = document.getElementById('register-form__agreement-option');
    const thirdpartyCheckbox = document.getElementById('register-form__agreement-thirdparty');
    const hiddenTagsInput = document.querySelector('.register-form__tag');
    const hiddenMarketingInput = document.getElementById('register-form__accepts_marketing');

    // Periksa jika elemen-elemen yang dibutuhkan tersedia
    if (!requiredCheckbox || !optionalCheckbox || !thirdpartyCheckbox || !hiddenTagsInput || !hiddenMarketingInput) {
        console.warn('Register form elements not found. Script skipped.');
        return;
    }

    /* ------------------------------------------
       CHECKBOX → HIDDEN INPUT SYNC
       Push tags to Shopify based on consent checkboxes
       ------------------------------------------ */
    function updateHiddenInputs() {
        let values = [];
        /* [DISABLED] ComoPassport tag — disabled per requestor */
        // values.push('ComoPassport');
        if (requiredCheckbox.checked) {
            values.push('newsletter');
            hiddenMarketingInput.value = "true";
        } else {
            hiddenMarketingInput.value = "false";
        }
        if (optionalCheckbox.checked) {
            values.push('acceptCustomerProfiling');
        }
        if (thirdpartyCheckbox.checked) {
            values.push('acceptThirdParties');
        }
        hiddenTagsInput.value = values.join(',');
    }

    function handleCheckboxChange(event) {
        const checkbox = event.target;
        const spanElement = checkbox.nextElementSibling;
        if (checkbox.checked) {
            spanElement.classList.add('checked');
        } else {
            spanElement.classList.remove('checked');
        }
        updateHiddenInputs();
    }

    requiredCheckbox.addEventListener('change', handleCheckboxChange);
    optionalCheckbox.addEventListener('change', handleCheckboxChange);
    thirdpartyCheckbox.addEventListener('change', handleCheckboxChange);

    updateHiddenInputs();

    /* Registration security (V-01/V-02) is handled by register-security.js */
});
